import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { AiFillDelete } from 'react-icons/ai';
import { RiPlayListAddFill } from 'react-icons/ri';
import { IoAddCircle } from 'react-icons/io5';
import { ImCancelCircle } from 'react-icons/im';
import {
	getDropdownCategory,
	getDropdownSubCategory,
	getDropdownProduct,
	getDropdownColor,
	getDropdownSize,
} from '../../../Redux/features/Stock/stockSlice';
import { DROPDOWN_FLAG } from '../../../config/config';
import { useDispatch, useSelector } from 'react-redux';
import { API_URL, formConfig } from '../../../config/config';
import { toast } from 'react-toastify';

// Function to compress image
// const compressImage = async (file) => {
// 	const img = document.createElement('img');
// 	img.src = URL.createObjectURL(file);
// 	await new Promise((resolve) => (img.onload = resolve));

// 	const canvas = document.createElement('canvas');
// 	const context = canvas.getContext('2d');
// 	const scale = 0.5; // Adjust scale as needed
// 	canvas.width = img.width * scale;
// 	canvas.height = img.height * scale;
// 	context.drawImage(img, 0, 0, canvas.width, canvas.height);

// 	return new Promise((resolve) => {
// 		canvas.toBlob(
// 			(blob) => {
// 				resolve(new File([blob], file.name, { type: file.type }));
// 			},
// 			file.type,
// 			0.7
// 		); // Adjust quality as needed
// 	});
// };

// const useDropdownFetch = (dispatch, dropdownFlag) => {
// 	const [hasFetched, setHasFetched] = useState(false);
// 	const [data, setData] = useState([]);

// 	useEffect(() => {
// 		if (hasFetched) return;

// 		const fetchData = async () => {
// 			try {
// 				const result = await dispatch(getDropdown(dropdownFlag));
// 				if (result?.payload?.stock) {
// 					setData(result.payload.stock);
// 				}

// 				setHasFetched(true);
// 			} catch (error) {
// 				console.error(`Failed to fetch dropdown data for ${dropdownFlag}:`, error);
// 			}
// 		};

// 		fetchData();
// 	}, [dispatch, hasFetched, dropdownFlag]);

// 	return [data, hasFetched];
// };

const NewProductUpload = () => {
	const dispatch = useDispatch();
	const fileInputRef = useRef(null);
	// Single useState for product data
	const [productData, setProductData] = useState({
		ProductName: '',
		Category: '',
		SubCategory: '',
		AllStockQty: '',
		ProductDescription: '',
		Rating: '',
		CreatedBy: 1,
		Stoke: {
			StokeDetails: [],
		},
	});

	const [DropdownData, setDropdownData] = useState({
		MasterType: '',
		MasterValue: '',
	});

	const [image, setImage] = useState(null);
	const [designList, setDesignList] = useState([]);
	const [categoryInput, setCategoryInput] = useState('');
	const [filteredCategoryOptions, setFilteredCategoryOptions] = useState([]);
	const { Category } = useSelector((state) => state.stock);
	const { SubCategory } = useSelector((state) => state.stock);
	const [selectedCategory, setSelectedCategory] = useState(null);
	const [subCategoryInput, setSubCategoryInput] = useState('');
	const [filteredSubCategoryOptions, setFilteredSubCategoryOptions] = useState([]);
	const [selectedSubCategory, setSelectedSubCategory] = useState(null);
	const [hasFetched, setHasFetched] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [filteredColorOptions, setFilteredColorOptions] = useState([]);
	const { Color } = useSelector((state) => state.stock);
	const [showColorDropdown, setShowColorDropdown] = useState(false);
	const [shouldShowAddNewColor, setShouldShowAddNewColor] = useState(false);
	const [filteredSizeOptions, setFilteredSizeOptions] = useState([]);
	const { Size } = useSelector((state) => state.stock);
	const [showSizeDropdown, setShowSizeDropdown] = useState(false);
	const [shouldShowAddNewSize, setShouldShowAddNewSize] = useState(false);

	const handleCategoryChange = (e) => {
		const value = e.target.value;
		setCategoryInput(value);
		setSelectedCategory(null);

		// Filter dropdown options dynamically
		const filtered = Category.filter((cat) =>
			cat.MasterValue.toLowerCase().includes(value.toLowerCase())
		);
		setFilteredCategoryOptions(filtered);
	};

	const selectCategory = (cat) => {
		setCategoryInput(cat.MasterValue);
		setSelectedCategory(cat.MasterValue); // Mark category as selected
		setFilteredCategoryOptions([]); // Clear dropdown options

		setProductData((prevState) => ({
			...prevState,
			Category: cat.MasterValue,
		}));
	};

	// Check if input matches any dropdown option
	const exactcategoryInputMatchExists = filteredCategoryOptions.some(
		(cat) => cat.MasterValue.toLowerCase() === categoryInput.toLowerCase()
	);

	// Show "Add this as new category" only if there's no exact match and no selection
	const shouldShowAddNewCategoryOption =
		categoryInput.trim() !== '' && !exactcategoryInputMatchExists && !selectedCategory;

	const handleSubCategoryChange = (e) => {
		const value = e.target.value;
		setSubCategoryInput(value);
		setSelectedSubCategory(null);

		// Filter dropdown options dynamically
		const filtered = SubCategory.filter((subcat) =>
			subcat.MasterValue.toLowerCase().includes(value.toLowerCase())
		);

		setFilteredSubCategoryOptions(filtered);
	};

	const selectSubCategory = (subcat) => {
		setSubCategoryInput(subcat.MasterValue);
		setSelectedSubCategory(subcat.MasterValue);
		setFilteredSubCategoryOptions([]); // Clear dropdown options

		setProductData((prevState) => ({
			...prevState,
			SubCategory: subcat.MasterValue,
		}));
	};

	// Check if exact match exists
	const exactSubCategoryInputMatchExists = SubCategory.some(
		(subcat) => subcat.MasterValue.toLowerCase() === subCategoryInput.toLowerCase()
	);

	// Show "Add new category" only when input does not match existing options

	const shouldShowAddNewSubCategoryOption =
		subCategoryInput.trim() !== '' && !exactSubCategoryInputMatchExists && !selectedSubCategory;

	const handleColorChange = (e) => {
		const value = e.target.value;
		setProductData({ ...productData, Color: value });

		const filtered = Color.filter((c) => c.MasterValue.toLowerCase().includes(value.toLowerCase()));
		setFilteredColorOptions(filtered);

		setShouldShowAddNewColor(
			value.trim() !== '' &&
				!filtered.some((c) => c.MasterValue.toLowerCase() === value.toLowerCase())
		);

		setShowColorDropdown(value.trim() !== '' || filtered.length > 0);
	};

	const selectColor = (c) => {
		setProductData({ ...productData, Color: c.MasterValue });
		setFilteredColorOptions([]);
		setShowColorDropdown(false);
	};

	const handleSizeChange = (e) => {
		const value = e.target.value;
		setProductData({ ...productData, Size: value });

		const filtered = Size.filter((s) => s.MasterValue.toLowerCase().includes(value.toLowerCase()));
		setFilteredSizeOptions(filtered);

		setShouldShowAddNewSize(
			value.trim() !== '' &&
				!filtered.some((s) => s.MasterValue.toLowerCase() === value.toLowerCase())
		);

		setShowSizeDropdown(value.trim() !== '' || filtered.length > 0);
	};

	const selectSize = (s) => {
		setProductData({ ...productData, Size: s.MasterValue });
		setFilteredSizeOptions([]);
		setShowSizeDropdown(false);
	};

	// const handleChange = (e) => {
	// 	const { name, value } = e.target;
	// 	if (!/^\d{0,5}$/.test(value) && (name === 'MRP' || name === 'Discount' || name === 'Qty')) {
	// 		return; // Do not allow invalid input
	// 	}
	// 	setProductData((prevData) => {
	// 		const updatedData = {
	// 			...prevData,
	// 			[name]: value,
	// 		};

	// 		// If MRP or Discount changes, perform the logic calculation
	// 		if (name === 'Discount' || name === 'MRP' || name === 'DiscountType') {
	// 			const mrpValue = parseFloat(updatedData.MRP) || 0;
	// 			let discountValue = parseFloat(updatedData.Discount) || 0;

	// 			if (updatedData.DiscountType === 'P') {
	// 				// Convert percentage to rupees
	// 				discountValue = (discountValue / 100) * mrpValue;
	// 			}

	// 			// Ensure discount is not more than MRP
	// 			if (discountValue > mrpValue) {
	// 				toast.error('Discount cannot be greater than MRP.');
	// 				discountValue = mrpValue; // Set it to MRP to avoid negative values
	// 			}

	// 			// Calculate DiscountMRP
	// 			updatedData.DiscountMRP = mrpValue - discountValue;
	// 		}

	// 		return updatedData;
	// 	});
	// };

	const handleChange = (e) => {
		const { name, value } = e.target;
		if (!/^\d{0,5}$/.test(value) && (name === 'MRP' || name === 'Discount' || name === 'Qty')) {
			return; // Do not allow invalid input
		}

		setProductData((prevData) => {
			const updatedData = {
				...prevData,
				[name]: value,
			};

			// If MRP, Discount, or DiscountType changes, recalculate the DiscountMRP
			if (name === 'Discount' || name === 'MRP' || name === 'DiscountType') {
				const mrpValue = parseFloat(updatedData.MRP) || 0;
				let discountValue = parseFloat(updatedData.Discount) || 0;

				if (updatedData.DiscountType === 'P') {
					// Convert percentage to rupees
					discountValue = (discountValue / 100) * mrpValue;
				}

				// Ensure discount is not more than MRP
				if (discountValue > mrpValue) {
					toast.error('Discount cannot be greater than MRP.');
					discountValue = mrpValue; // Set to MRP to avoid negative values
				}

				// Calculate DiscountMRP and round off if DiscountType is percentage
				updatedData.DiscountMRP =
					updatedData.DiscountType === 'P'
						? Math.round(mrpValue - discountValue) // Round off for percentage
						: mrpValue - discountValue; // Keep as-is for Rupees
			}

			return updatedData;
		});
	};

	useEffect(() => {
		if (Color.length === 0 && !hasFetched) {
			dispatch(getDropdownColor(DROPDOWN_FLAG.COLOR));
			setHasFetched(true);
		}
	}, [dispatch, Color, hasFetched]);

	useEffect(() => {
		if (Size.length === 0 && !hasFetched) {
			dispatch(getDropdownSize(DROPDOWN_FLAG.SIZE));
			setHasFetched(true);
		}
	}, [dispatch, Size, hasFetched]);

	useEffect(() => {
		if (SubCategory.length === 0 && !hasFetched) {
			dispatch(getDropdownSubCategory(DROPDOWN_FLAG.SUBCATEGORY));
			setHasFetched(true);
		}
	}, [dispatch, SubCategory, hasFetched]);

	useEffect(() => {
		if (Category.length === 0 && !hasFetched) {
			dispatch(getDropdownCategory(DROPDOWN_FLAG.CATEGORY));
			setHasFetched(true);
		}
	}, [dispatch, Category, hasFetched]);

	const handleFileChange = (e) => {
		const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
		const file = e.target.files[0];

		if (file) {
			if (!allowedTypes.includes(file.type)) {
				toast.error('Only image files are allowed.');
				e.target.value = ''; // Clear invalid file input
				return;
			}

			// Create an object URL to preview the image
			const fileURL = URL.createObjectURL(file);

			setProductData((prevData) => ({
				...prevData,
				ProductThumbnails: {
					ImagePath: file,
					ImagePathPreview: fileURL,
				},
			}));
		}
	};

	const [showImage, setShowImage] = useState(null);

	const handleImageChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			setImage(file);
			const imageURL = URL.createObjectURL(file);
			setShowImage(imageURL);
		}
	};

	const addItem = (e) => {
		e.preventDefault();

		// Check if all required fields are filled
		if (
			!productData.Color ||
			!productData.Size ||
			!productData.MRP ||
			!productData.Qty ||
			!productData.DiscountMRP ||
			!productData.Discount ||
			!productData.DiscountType ||
			!productData.ProductThumbnails?.ImagePath
		) {
			toast.error('Please fill all required fields including an image.');
			return;
		}

		// Create new stock object
		const newStock = {
			Color: productData.Color,
			Size: productData.Size,
			MRP: productData.MRP,
			// Qty: productData.Qty,
			Qty: parseInt(productData.Qty) || 1,
			DiscountMRP: productData.DiscountMRP,
			Discount: productData.Discount,
			DiscountType: productData.DiscountType,
			Rating: productData.Rating || 1,
			ProductThumbnails: {
				ImagePath: productData.ProductThumbnails.ImagePath,
				ImagePathPreview: productData.ProductThumbnails.ImagePathPreview,
			},
		};

		setProductData((prevData) => {
			const updatedStokeDetails = [...prevData.Stoke.StokeDetails, newStock];

			// Calculate total quantity
			const totalQty = updatedStokeDetails.reduce((sum, stock) => sum + stock.Qty, 0);

			return {
				...prevData,
				Stoke: {
					...prevData.Stoke,
					StokeDetails: updatedStokeDetails,
				},
				AllStockQty: totalQty, // Update total quantity
			};
		});

		setDesignList((prevList) => [...prevList, newStock]);

		// Reset relevant fields in productData
		setProductData((prevData) => ({
			...prevData,
			Color: '',
			Size: '',
			MRP: '',
			Qty: '',
			DiscountMRP: '',
			Discount: '',
			DiscountType: '',
			ProductThumbnails: {
				ImagePath: null,
				ImagePathPreview: null,
			},
		}));

		// Clear the file input field
		if (fileInputRef.current) {
			fileInputRef.current.value = '';
		}
	};

	const deleteItem = (index) => {
		// Remove item from designList
		const updatedList = designList.filter((_, i) => i !== index);
		setDesignList(updatedList);

		// Also update productData.Stoke.StokeDetails
		setProductData((prevData) => ({
			...prevData,
			Stoke: {
				...prevData.Stoke,
				StokeDetails: updatedList, // Update StokeDetails with the new list
			},
		}));
	};

	const handleDropdownChange = (e) => {
		const { name, value } = e.target;
		const formattedValue = value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

		setDropdownData((prevData) => ({
			...prevData,
			[name]: formattedValue,
		}));
	};

	const handleSubmitDropdown = async (e) => {
		e.preventDefault();

		if (!DropdownData.MasterType || !DropdownData.MasterValue) {
			return toast.error('Please fill in all fields.');
		}

		const uploadData = new FormData();
		uploadData.append('MasterType', DropdownData.MasterType);
		uploadData.append('MasterValue', DropdownData.MasterValue);

		const data = {
			MasterType: DropdownData.MasterType,
			MasterValue: DropdownData.MasterValue,
		};

		try {
			const response = await axios.post(`${API_URL}/addStock/addDropdown`, data, formConfig);
			if (response?.data?.success) {
				if (DropdownData.MasterType === 3) {
					dispatch(getDropdownProduct(DROPDOWN_FLAG.PRODUCT));
				} else if (DropdownData.MasterType === 4) {
					dispatch(getDropdownColor(DROPDOWN_FLAG.COLOR));
				} else if (DropdownData.MasterType === 5) {
					dispatch(getDropdownCategory(DROPDOWN_FLAG.CATEGORY));
				} else if (DropdownData.MasterType === 7) {
					dispatch(getDropdownSize(DROPDOWN_FLAG.SIZE));
				} else if (DropdownData.MasterType === 10) {
					dispatch(getDropdownSubCategory(DROPDOWN_FLAG.SUBCATEGORY));
				}

				toast.success(response?.data?.message);
				setDropdownData({ MasterType: '', MasterValue: '' });

				handleCloseModal();
			} else {
				toast.error(response?.data?.message || 'Unexpected error.');
			}
		} catch (error) {
			toast.error(error?.response?.data?.message || 'An error occurred.');
		}
	};

	const handleModal = (masterType) => {
		setDropdownData({
			MasterType: masterType,
			MasterValue: '',
		});
		setShowModal(true);
	};

	const handleCloseModal = () => {
		setShowModal(false);
		setDropdownData({
			MasterType: '',
			MasterValue: '',
		});
	};

	const handleSubmit = async (e) => {
		try {
			e.preventDefault();

			// Ensure StokeDetails is always an array
			const StokeDetails = productData?.Stoke?.StokeDetails || [];

			const form = new FormData();
			form.append('ProductName', productData.ProductName);
			form.append('Category', productData.Category);
			form.append('SubCategory', productData.SubCategory);
			form.append('AllStockQty', productData.AllStockQty);
			form.append('ProductDescription', productData.ProductDescription);
			form.append('Rating', productData.Rating);
			form.append('CreatedBy', productData.CreatedBy);

			// If an image is uploaded, append it as ParentImagePath
			if (image) {
				form.append('ParentImagePath', image);
			} else if (productData.ImagePath) {
				form.append('ParentImagePath', productData.ImagePath);
			}

			// Convert StokeDetails to JSON
			const Stoke = {
				StokeDetails: StokeDetails.map((stock) => ({
					Color: stock.Color,
					Size: stock.Size,
					MRP: stock.MRP,
					Qty: stock.Qty,
					DiscountMRP: stock.DiscountMRP,
					Discount: stock.Discount,
					DiscountType: stock.DiscountType,
				})),
			};

			form.append('Stoke', JSON.stringify(Stoke));

			// Append images correctly
			StokeDetails.forEach((stock) => {
				if (stock.ProductThumbnails?.ImagePath) {
					form.append('ImagePath', stock.ProductThumbnails.ImagePath);
				}
			});

			const response = await axios.post(`${API_URL}/addStock/Addstock`, form, formConfig);

			if (response.data.success) {
				setProductData({
					ProductName: '',
					Category: '',
					categoryInput: '',
					SubCategory: '',
					subCategoryInput: '',
					AllStockQty: '',
					ProductDescription: '',
					Rating: '',
					CreatedBy: 1,
					ParentImagePath: null,
					Stoke: { StokeDetails: [] },
				});
				toast.success(`${productData.ProductName} Added to Stock Successfully`);
				setProductData({
					ProductName: '',
					Category: '',
					categoryInput: '',
					SubCategory: '',
					subCategoryInput: '',
					AllStockQty: '',
					ProductDescription: '',
					Rating: '',
					CreatedBy: 1,
					Stoke: { StokeDetails: [] },
				});
				setSubCategoryInput('');
				setCategoryInput('');
				setFilteredCategoryOptions([]);
				setShowImage(null);
				setImage(null);
				setDesignList([]);

				if (fileInputRef.current) {
					fileInputRef.current.value = '';
				}
			}
		} catch (error) {
			toast.error(error?.response?.data?.message || 'Something went wrong.');
		}
	};

	return (
		<div>
			<div>
				<form onSubmit={handleSubmit}>
					<div className=' flex md:flex-row flex-col gap-2'>
						<div className=' border-2 bg-white bg-opacity-5 py-5 md:px-10 px-5 shadow-lg rounded-lg  md:w-[55%]'>
							{/* Category  */}
							<div className=' mb-3 '>
								<label className='text-sm font-medium'>Category</label>
								<div className='flex flex-col relative'>
									<div className=' flex flex-row gap-5 '>
										<input
											type='text'
											name='Category'
											value={categoryInput}
											onChange={handleCategoryChange}
											className=' border rounded p-2 w-full'
											placeholder='Search Category'
											autoComplete='off'
										/>
										<div className='relative inline-block group'>
											{/* Button with hover effect */}
											<button
												type='button'
												onClick={() => handleModal(5)} // Correctly wrapped
												className=''>
												<IoAddCircle className='text-[44px] hover:text-green-600 text-green-500' />
											</button>
											{/* Tooltip that appears on hover */}
											<div className='absolute md:top-[40px] max-md:-top-4 max-md:w-28  md:w-32  md:-left-[20%] max-md:-left-10 text-center transform-translate-x-1/2  px-2 py-1 max-md:bg-transparent bg-black bg-opacity-20 text-black text-opacity-80 font-semibold md:text-[11px] text-[9px] rounded md:shadow-lg md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-200'>
												Add New Category
											</div>
										</div>
									</div>
									{/* {filteredCategoryOptions.length > 0 && ( */}
									{categoryInput.trim() !== '' && (
										<div className='absolute top-[52px] w-[80%] rounded max-h-60 overflow-y-auto custom-scrollbar z-10  '>
											{filteredCategoryOptions.length > 0 ? (
												filteredCategoryOptions.map((cat) => (
													<div
														key={cat.MasterValue}
														className=' py-2 border-b text-sm px-4  border bg-gray-200 hover:bg-gray-100 cursor-pointer'
														onClick={() => selectCategory(cat)}>
														{cat.MasterValue}
													</div>
												))
											) : (
												<div className=' z-0'></div>
											)}

											{shouldShowAddNewCategoryOption && (
												<div
													className=' py-2 border-b text-sm px-4  border bg-gray-200 hover:bg-gray-100 cursor-pointer'
													onClick={() => handleModal(5)}>
													+ Add this as new category: &quot;{categoryInput}&quot;
												</div>
											)}
										</div>
									)}
								</div>
							</div>

							{/* subcategory  */}
							<div className='mb-3'>
								<label className='text-sm font-medium'>SubCategory</label>
								<div className='flex flex-col relative'>
									<div className='flex flex-row gap-5'>
										<input
											type='text'
											name='SubCategory'
											value={subCategoryInput}
											onChange={handleSubCategoryChange}
											className='border rounded p-2 w-full'
											placeholder='Search SubCategory'
											autoComplete='off'
										/>
										<div className='relative inline-block group'>
											<button
												type='button'
												onClick={() => handleModal(10)} // Corrected modal function call
												className=''>
												<IoAddCircle className='text-[44px] hover:text-green-600 text-green-500' />
											</button>
											<div className='absolute md:top-[40px] max-md:-top-4 max-md:w-28 md:w-32 md:-left-[20%] max-md:-left-10 text-center px-2 py-1 max-md:bg-transparent bg-black bg-opacity-20 text-black text-opacity-80 font-semibold md:text-[11px] text-[9px] rounded md:shadow-lg md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-200'>
												Add New SubCategory
											</div>
										</div>
									</div>
									{subCategoryInput.trim() !== '' && (
										<div className='absolute top-[52px] w-[80%] rounded max-h-60 overflow-y-auto custom-scrollbar z-10'>
											{/* If there are matches, show them */}
											{filteredSubCategoryOptions.length > 0 ? (
												filteredSubCategoryOptions.map((subcat) => (
													<div
														key={subcat.MasterValue}
														className='py-2 border-b text-sm px-4 border bg-gray-200 hover:bg-gray-100 cursor-pointer'
														onClick={() => selectSubCategory(subcat)}>
														{subcat.MasterValue}
													</div>
												))
											) : (
												<div></div>
											)}

											{/* Show "Add new category" option if input doesn't match any existing category */}
											{shouldShowAddNewSubCategoryOption && (
												<div
													className='py-2 border-b text-sm px-4 border bg-gray-200 hover:bg-gray-100 cursor-pointer'
													onClick={() => handleModal(10)}>
													+ Add this as new Subcategory: &quot;{subCategoryInput}&quot;
												</div>
											)}
										</div>
									)}
								</div>
							</div>

							<div className=' mb-3 '>
								<label>Product Name</label>
								<div className=' flex flex-col relative'>
									<div className=' flex flex-row gap-5'>
										<textarea
											rows={1}
											type='text'
											name='ProductName'
											value={productData.ProductName}
											onChange={(e) => {
												const formattedText = e.target.value
													.toLowerCase()
													.replace(/\b\w/g, (char) => char.toUpperCase());
												setProductData({ ...productData, ProductName: formattedText });
											}}
											className='border rounded p-2 w-full'
											placeholder='Enter Product Name'
											autoComplete='off'
										/>
									</div>
								</div>
							</div>
							<div>
								<label>Product Description</label>
								<textarea
									placeholder=' Enter Product Description'
									rows={2}
									name='ProductDescription'
									value={productData.ProductDescription}
									onChange={(e) => {
										const formattedText = e.target.value
											.toLowerCase()
											.replace(/\b\w/g, (char) => char.toUpperCase());
										setProductData({ ...productData, ProductDescription: formattedText });
									}}
									className=' border rounded p-2 w-full'
								/>
							</div>
							<div className=' '>
								<div className=' flex flex-col w-full'>
									<label className='text-sm font-medium mb-1'>Add Main Thumbnail</label>
									<input
										className='border rounded p-2 w-full'
										type='file'
										accept='image/*'
										onChange={handleImageChange}
										ref={fileInputRef}
									/>
								</div>
								{showImage && (
									<div>
										<img
											src={showImage}
											className='w-16 h-16 md:w-24 md:h-24 object-cover cursor-pointer mt-2'
											alt='Preview'
										/>
									</div>
								)}
							</div>
							<div>
								<label>Add Rating</label>
								<input
									type='text'
									placeholder='Add Product Rating (1.0 - 5.0)'
									name='Rating'
									value={productData.Rating}
									onChange={(e) => {
										let value = e.target.value;

										// Allow only numbers with up to one decimal place
										if (!/^\d?(\.\d?)?$/.test(value)) return;

										// Convert to number
										let numValue = parseFloat(value);

										// Allow empty value for deletion
										if (value === '' || isNaN(numValue)) {
											setProductData({ ...productData, Rating: '' });
											return;
										}

										// If user enters a number > 5, set it to 5 immediately
										if (numValue > 5) {
											numValue = 5;
										}

										// Update state with the formatted number
										setProductData({ ...productData, Rating: value });
									}}
									onBlur={() => {
										if (productData.Rating) {
											let numValue = parseFloat(productData.Rating);

											// Ensure value stays within 1.0 - 5.0
											if (numValue < 1) numValue = 1;
											if (numValue > 5) numValue = 5;

											// Set rounded value with one decimal place
											setProductData({ ...productData, Rating: numValue.toFixed(1) });
										}
									}}
									className='border rounded p-2 w-full'
								/>
							</div>

							{productData.AllStockQty > 0 && (
								<p className=' mt-4 text-sm font-medium mb-1'>
									Total Quantity (Stock): {productData.AllStockQty}
								</p>
							)}
						</div>
						{/* design form */}
						<div className='  shadow-md border-2 py-5 md:px-10 px-5 rounded-md '>
							<p className=' font-medium md:text-xl sm:text-lg text-base mb-1'>
								Add Article Designs
							</p>
							<div className=' border-[1px] border-black sm:mb-8 mb-6 sm:w-12 w-10 ' />
							<div className='grid grid-cols-1 gap-6 mb-6'>
								<div className=' flex md:flex-row flex-col w-full gap-4'>
									<div className='flex flex-col relative w-full'>
										<label className='text-sm font-medium mb-1'>Color</label>
										<div className=' flex flex-row  items-center'>
											<div className=' w-full'>
												<input
													name='Color'
													type='text'
													className='border rounded p-2 w-full'
													placeholder='Search Color'
													value={productData.Color}
													onChange={handleColorChange}
													autoComplete='off'
												/>
											</div>
											<div className='relative inline-block group'>
												{/* Button with hover effect */}
												<button
													type='button'
													onClick={() => handleModal(4)} // Correctly wrapped
													className=''>
													<IoAddCircle className=' text-[44px] hover:text-green-600 text-green-500' />
												</button>

												{/* Tooltip that appears on hover */}
												<div className='absolute md:top-[40px] z-20 max-md:-top-4 max-md:w-28  md:w-32  md:-left-[20%] max-md:-left-10 text-center transform-translate-x-1/2  px-2 py-1 max-md:bg-transparent bg-black bg-opacity-20 text-black text-opacity-80 font-semibold md:text-[11px] text-[9px] rounded md:shadow-lg md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-200'>
													Add New Color
												</div>
											</div>
										</div>
										{showColorDropdown && productData?.Color?.trim() !== '' && (
											<div className='absolute top-[72px] w-[87%] rounded max-h-60 overflow-y-auto custom-scrollbar z-10 bg-white shadow-md'>
												{filteredColorOptions.length > 0 ? (
													filteredColorOptions.map((c) => (
														<div
															key={c.MasterValue}
															className='py-2 border-b text-sm px-4 bg-gray-200 hover:bg-gray-100 cursor-pointer'
															onClick={() => selectColor(c)}>
															{c.MasterValue}
														</div>
													))
												) : (
													<div className='z-0'></div>
												)}

												{shouldShowAddNewColor && (
													<div
														className='py-2 border-b text-sm px-4 bg-gray-200 hover:bg-gray-100 cursor-pointer'
														onClick={() => handleModal(4)}>
														+ Add this as new color: &quot;{productData.Color}&quot;
													</div>
												)}
											</div>
										)}
									</div>

									<div className='flex flex-col relative w-full'>
										<label className='text-sm font-medium mb-1'>Size:</label>
										<div className=' flex flex-row  items-center'>
											<div className=' w-full'>
												<input
													type='text'
													name='Size'
													className='border rounded p-2 w-full'
													placeholder='Search Size'
													value={productData.Size}
													onChange={handleSizeChange}
													autoComplete='off'
												/>
											</div>
											<div className='relative inline-block group'>
												<button type='button' onClick={() => handleModal(7)} className=''>
													<IoAddCircle className='text-[44px] hover:text-green-600 text-green-500' />
												</button>

												<div className='absolute z-20 md:top-[40px] max-md:-top-4 max-md:w-28  md:w-32  md:-left-[20%] max-md:-left-10 text-center transform-translate-x-1/2  px-2 py-1 max-md:bg-transparent bg-black bg-opacity-20 text-black text-opacity-80 font-semibold md:text-[11px] text-[9px] rounded md:shadow-lg md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-200'>
													Add New Size
												</div>
											</div>
										</div>

										{showSizeDropdown && productData?.Size?.trim() !== '' && (
											<div className='absolute top-[72px] w-[87%] rounded max-h-60 overflow-y-auto custom-scrollbar z-10 bg-white shadow-md'>
												{filteredSizeOptions.length > 0 ? (
													filteredSizeOptions.map((s) => (
														<div
															key={s.MasterValue}
															className='py-2 border-b text-sm px-4 bg-gray-200 hover:bg-gray-100 cursor-pointer'
															onClick={() => selectSize(s)}>
															{s.MasterValue}
														</div>
													))
												) : (
													<div className='z-0'></div>
												)}

												{shouldShowAddNewSize && (
													<div
														className='py-2 border-b text-sm px-4 bg-gray-200 hover:bg-gray-100 cursor-pointer'
														onClick={() => handleModal(7)}>
														+ Add this as new Size: &quot;{productData.size}&quot;
													</div>
												)}
											</div>
										)}
									</div>
								</div>
								<div className=' md:flex md:flex-row grid grid-cols-2  w-full gap-4'>
									<div className='flex flex-col w-full'>
										<label className='text-sm font-medium mb-1'>Price:</label>
										<input
											name='MRP'
											value={productData.MRP}
											onChange={handleChange}
											type='number'
											className='border rounded p-2 w-full'
											placeholder='Enter Price'
										/>
									</div>

									<div className='flex flex-col w-full'>
										<label className='text-sm font-medium mb-1'>Discount:</label>
										<input
											type='number'
											name='Discount'
											value={productData.Discount}
											onChange={handleChange}
											className='border rounded p-2 w-full'
											placeholder='Enter Discount'
										/>
									</div>
									<div className='flex flex-col w-full'>
										<label className='text-sm font-medium mb-1'>Discount Type:</label>

										<select
											name='DiscountType'
											value={productData.DiscountType}
											onChange={handleChange}
											className='border rounded p-2 w-full bg-white font-serif'>
											<option value=''>Select Discount Type</option>
											<option value='P'>Percentage (%) </option>
											<option value='R'>Rupees (₹)</option>
										</select>
									</div>

									<div className='flex flex-col w-full'>
										<label className='text-sm font-medium mb-1'>Discount MRP:</label>
										<input
											type='text'
											name='DiscountMRP'
											value={productData.DiscountMRP}
											className='border rounded p-2 w-full'
											placeholder='Discount MRP'
											readOnly
										/>
									</div>
								</div>
								<div className=' flex md:flex-row flex-col w-full gap-4'>
									<div className=' flex flex-col w-full'>
										<label className='text-sm font-medium mb-1'>Quantity:</label>
										<input
											type='text'
											name='Qty'
											value={productData.Qty}
											onChange={handleChange}
											className='border rounded p-2 w-full'
											placeholder=' Enter Quantity'
										/>
									</div>
									<div className='flex flex-col w-full'>
										<label className='text-sm font-medium mb-1'>Add Thumbnail:</label>
										<input
											type='file'
											className='border rounded p-2 w-full'
											placeholder='Thumbnail'
											onChange={(e) => handleFileChange(e)}
											ref={fileInputRef}
										/>
									</div>
								</div>
								<div className='flex items-center gap-5 w-full'>
									<button
										onClick={addItem}
										className='bg-blue-500 text-white px-4 py-2 rounded w-fit flex flex-row justify-center items-center gap-2'>
										Add Design <RiPlayListAddFill />
									</button>
								</div>
							</div>
						</div>
					</div>
					{/* Table Section */}
					{designList.length > 0 && (
						<div className='overflow-x-auto'>
							<table className='border-collapse border border-gray-200 mt-4 w-full min-w-max'>
								<thead>
									<tr className='bg-gray-100 text-sm'>
										<th className=' border p-2'>Designs</th>
										<th className='border p-2'>Color</th>
										<th className='border p-2'>Size</th>
										<th className='border p-2'>Price</th>
										<th className='border p-2'>Discount type</th>
										<th className='border p-2'>Discount</th>
										<th className='border p-2'>Quantity</th>
										<th className='border p-2'>Thumbnail</th>
										<th className='border p-2'>Action</th>
									</tr>
								</thead>
								<tbody>
									{designList.map((item, index) => (
										<tr key={index} className='border text-center text-sm'>
											<td className='border p-2'>Design#{index + 1}</td>
											<td className='border p-2'>{item.Color}</td>
											<td className='border p-2'>{item.Size}</td>
											<td className='border p-2'>
												<span className=' font-serif '>₹</span>
												{item.MRP}
											</td>

											<td className='border p-2'>
												{item.DiscountType === 'R' ? (
													<>
														<span className='font-serif'>₹</span>
														{item.Discount}
													</>
												) : item.DiscountType === 'P' ? (
													<>
														{item.Discount}
														<span>%</span>
													</>
												) : (
													item.Discount
												)}
											</td>
											<td className='border p-2'>
												<span className=' font-serif '>₹</span>
												{item.DiscountMRP}
											</td>
											<td className='border p-2'>{item.Qty}</td>

											<td className='border p-1 flex justify-center items-center '>
												{item?.ProductThumbnails?.ImagePathPreview ? (
													<img
														src={item?.ProductThumbnails?.ImagePathPreview}
														alt='Thumbnail'
														className='w-16 h-16 object-cover rounded-md flex justify-center items-center'
													/>
												) : (
													<span className='text-gray-500'>No Image</span>
												)}
											</td>

											<td className='border p-2'>
												<button
													type='button'
													onClick={() => deleteItem(index)}
													className='text-red-500 text-xl'>
													<AiFillDelete />
												</button>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					)}
					<button className=' mt-3 proBtn rounded-md w-36' type='submit'>
						Save
					</button>
				</form>

				{showModal && (
					<div className='fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50'>
						<div className='bg-white p-6 rounded-md w-[90%] sm:w-[70%] md:w-[50%] lg:w-[40%] xl:w-[30%] relative'>
							<ImCancelCircle
								onClick={handleCloseModal}
								className='text-red-500 absolute right-3 top-3 text-2xl font-bold cursor-pointer'
							/>
							<form onSubmit={handleSubmitDropdown}>
								<div className='mt-3'>
									<input
										type='text'
										name='MasterValue'
										value={DropdownData.MasterValue}
										onChange={handleDropdownChange}
										className='w-full bg-gray-100 text-gray-900 mt-3 mb-4 p-3 focus:shadow-outline border-[0.25px] rounded-md'
										placeholder='Enter New Dropdown Value'
									/>
								</div>
								<div className='mt-4 flex justify-end'>
									<button
										type='submit'
										className='w-full sm:w-auto text-white bg-red-500 px-4 py-3 font-semibold text-sm rounded-md'>
										Save
									</button>
								</div>
							</form>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default NewProductUpload;
